(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8510],{

/***/ 31298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ preguntas_frecuentes; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Remove.js
var Remove = __webpack_require__(94895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/Typography/index.tsx
var Typography = __webpack_require__(85127);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
;// CONCATENATED MODULE: ./shared/models/const/frequency-questions.const.ts
var CFrequencyQuestions = {
  es: [{
    question: "¿Cuáles son los beneficios de entrar a REMAX?",
    answer: "Entrar a REMAX te permite desarrollar tu propio negocio inmobiliario bajo un modelo probado a nivel mundial. Obtienes independencia, altos niveles de comisión, respaldo de marca, acceso a herramientas tecnológicas, formación continua y una red de colaboración tanto local como internacional."
  }, {
    question: "¿Cuál es la diferencia entre las oficinas REMAX?",
    answer: "Cada oficina REMAX es una franquicia independiente. Aunque todas operan bajo los mismos estándares y la misma marca, cada Broker Owner define su propuesta de valor, sus servicios complementarios y su cultura interna. Por eso es importante que evalúes qué oficina se alinea mejor con tus necesidades y objetivos."
  }, {
    question: "¿Qué es REMAX RD y cuál es la diferencia con las oficinas?",
    answer: "REMAX República Dominicana es la oficina regional que representa la marca en el país y da soporte a las franquicias. No operamos directamente con clientes ni tenemos agentes; nuestro rol es brindar soporte, supervisión, capacitación y desarrollo a los Brokers y a sus oficinas. Cada oficina REMAX es independiente en su operación y reclutamiento de agentes."
  }, {
    question: "¿Puedo ingresar sin experiencia en ventas?",
    answer: "Sí. Contamos con programas de formación continua y un acompañamiento inicial que te permitirá aprender sobre el negocio inmobiliario, las ventas y el funcionamiento del modelo. Lo más importante es tu actitud, disciplina y compromiso con tu propio crecimiento."
  }, {
    question: "¿Cuánto me paga REMAX?",
    answer: "En REMAX tú no eres un empleado, sino un agente independiente. Tu ingreso dependerá de las comisiones generadas por tus ventas o alquileres. Las oficinas REMAX ofrecen uno de los modelos de comisión más altos del mercado inmobiliario."
  }, {
    question: "¿Cómo funciona el esquema de comisión cuando vendo o alquilo una propiedad?",
    answer: "Cada vez que realizas una transacción, recibes un porcentaje de la comisión inmobiliaria que se cobra al cliente. Ese porcentaje depende del plan (split) que tengas contratado con tu oficina. Generalmente, los splits van desde un 50% hasta un 80% para el agente, lo que significa que tú conservas la mayor parte de tus ingresos. Esto te permite trabajar bajo un modelo donde, mientras más produces, mayor es tu rentabilidad."
  }, {
    question: "¿Por qué tengo que pagar para estar en REMAX?",
    answer: "Al ser un agente independiente y tener tu propio negocio bajo la marca REMAX, asumes ciertos costos operativos relacionados con el uso de la marca, las herramientas tecnológicas, la capacitación y el soporte que recibes. Este modelo permite que mantengas un porcentaje mayor de tus ingresos en comparación con otros modelos tradicionales."
  }, {
    question: "¿Cuál es la diferencia entre los splits de comisión?",
    answer: "Los splits son los planes que definen qué porcentaje de la comisión recibe el agente y qué porcentaje la oficina. A mayor split (por ejemplo, 80%), mayor es la cuota fija mensual, ya que te permite retener un mayor porcentaje de tus comisiones. Por el contrario, si eliges un split más bajo (como 50%), pagas una cuota mensual más reducida, pero la oficina retiene un porcentaje mayor de cada transacción. Este modelo te permite elegir el plan que más se adapte a tu etapa profesional, tu capacidad operativa y tus objetivos de ingresos."
  }, {
    question: "¿Cuál es la diferencia entre asociado senior y asociado junior?",
    answer: "El asociado junior trabaja siempre dentro de un equipo liderado por un asociado senior, quien le brinda apoyo y mentoría. Tiene un split menor y una cuota más baja. El asociado senior opera de forma independiente o puede liderar su propio equipo, accediendo a splits más altos y mayores beneficios."
  }, {
    question: "¿Cuál es la diferencia entre la cuota regional y la cuota de oficina?",
    answer: "La cuota regional es el pago que realizan todos los agentes asociados para tener acceso a las plataformas tecnológicas globales, capacitación continua, soporte regional y derechos de uso de la marca REMAX. La cuota de oficina cubre los servicios y recursos que ofrece cada franquicia local (espacio físico, acompañamiento, soporte administrativo, etc.)."
  }, {
    question: "¿Cuánto dinero me voy a ganar dentro de REMAX?",
    answer: "Tu ingreso es ilimitado y depende exclusivamente de tu productividad. No existen topes de comisión ni limitaciones. Mientras más cierres, más ganas."
  }, {
    question: "¿Puedo cambiar de asociado junior a asociado senior?",
    answer: "Sí. Una vez cumplas con los requisitos establecidos por tu oficina (normalmente basados en tu nivel de producción o tiempo en la marca), puedes solicitar el cambio a un plan de asociado senior."
  }, {
    question: "¿Puedo cambiar de oficina luego de haber entrado?",
    answer: "Sí, puedes solicitar tu traslado a otra oficina REMAX dentro del país, siempre que cuentes con el acuerdo de ambos Broker Owners (el de tu oficina actual y el de la oficina a la que deseas trasladarte). Es indispensable estar al día con tus compromisos económicos y administrativos antes de realizar el cambio."
  }, {
    question: "¿Puedo cambiar de equipo luego de haber entrado?",
    answer: "Sí. Si dentro de tu oficina trabajas en un equipo y deseas cambiar a otro equipo o trabajar de manera independiente, puedes hacerlo siguiendo los lineamientos internos de tu oficina."
  }, {
    question: "¿Tengo que producir un mínimo de comisiones para permanecer en la marca?",
    answer: "No existe un mínimo de producción exigido desde la marca a nivel regional. Sin embargo, cada oficina puede establecer lineamientos internos para evaluar la productividad de sus agentes. Además, es importante considerar que, al ser un negocio independiente, debes generar ingresos que te permitan cubrir tus costos operativos."
  }, {
    question: "¿Qué pasa si no vendo en un mes?",
    answer: "No hay penalización por no vender en un mes. Lo único que debes mantener son tus cuotas fijas (regional y de oficina). Es un modelo que permite que tú gestiones tu tiempo y esfuerzo según tus objetivos personales."
  }, {
    question: "¿REMAX me da las propiedades para que las venda?",
    answer: "No. Tú eres responsable de captar tus propias propiedades y clientes. Sin embargo, trabajas en una red colaborativa donde puedes acceder a las propiedades que otros agentes tienen en exclusiva y comercializarlas, generando así mayores oportunidades de negocio."
  }, {
    question: "¿Puedo promocionar y vender las propiedades de otros agentes?",
    answer: "Sí. El modelo REMAX fomenta la colaboración. Puedes promocionar, mostrar y vender propiedades captadas por otros agentes de tu misma oficina o incluso de otras oficinas REMAX, compartiendo la comisión según los acuerdos establecidos."
  }, {
    question: "¿Tengo que cumplir un horario laboral?",
    answer: "No. Tú eres dueño de tu tiempo. No hay un horario establecido ni obligación de asistencia diaria. El modelo te ofrece flexibilidad total para organizar tu agenda según tus objetivos personales y profesionales."
  }],
  en: [{
    question: "What are the benefits of joining REMAX?",
    answer: "Joining REMAX lets you build your own real estate business under a globally proven model. You gain independence, high commission levels, brand backing, access to technology tools, continuous training, and a collaborative network both locally and internationally."
  }, {
    question: "What’s the difference between REMAX offices?",
    answer: "Each REMAX office is an independent franchise. While all operate under the same standards and brand, each Broker Owner defines the value proposition, complementary services, and internal culture. It’s important to evaluate which office best aligns with your needs and goals."
  }, {
    question: "What is REMAX RD and how does it differ from the offices?",
    answer: "REMAX Dominican Republic is the regional office that represents the brand in the country and supports the franchises. We do not work directly with clients nor have agents; our role is to provide support, oversight, training, and development to Brokers and their offices. Each REMAX office operates and recruits independently."
  }, {
    question: "Can I join without sales experience?",
    answer: "Yes. We have continuous training programs and initial onboarding to help you learn the real estate business, sales, and how the model works. Your attitude, discipline, and commitment to your own growth matter most."
  }, {
    question: "How much does REMAX pay me?",
    answer: "At REMAX you are not an employee; you are an independent agent. Your income depends on commissions generated by your sales or rentals. REMAX offices offer some of the highest commission models in the real estate market."
  }, {
    question: "How does the commission split work when I sell or rent a property?",
    answer: "Every time you close a transaction, you receive a percentage of the real estate commission charged to the client. That percentage depends on the split plan you have with your office. Splits typically range from 50% to 80% to the agent, which means you keep most of your earnings. The more you produce, the higher your profitability."
  }, {
    question: "Why do I have to pay to be in REMAX?",
    answer: "As an independent agent running your own business under the REMAX brand, you assume certain operating costs related to brand usage, technology tools, training, and the support you receive. This model lets you retain a larger share of your income compared to traditional models."
  }, {
    question: "What’s the difference between commission splits?",
    answer: "Splits define what percentage of the commission the agent receives and what percentage the office receives. Higher splits (e.g., 80%) come with a higher fixed monthly fee because they let you retain a larger percentage of your commissions. Conversely, a lower split (e.g., 50%) has a lower monthly fee but the office retains a larger percentage per transaction. This model lets you choose the plan that best fits your career stage, operating capacity, and income goals."
  }, {
    question: "What’s the difference between a senior associate and a junior associate?",
    answer: "A junior associate always works within a team led by a senior associate, who provides support and mentorship. They have a lower split and a lower monthly fee. A senior associate operates independently or can lead their own team, accessing higher splits and greater benefits."
  }, {
    question: "What’s the difference between the regional fee and the office fee?",
    answer: "The regional fee is paid by all associated agents to access global technology platforms, continuous training, regional support, and the right to use the REMAX brand. The office fee covers the services and resources offered by each local franchise (physical space, coaching, administrative support, etc.)."
  }, {
    question: "How much money will I earn at REMAX?",
    answer: "Your income is unlimited and depends solely on your productivity. There are no commission caps or limitations. The more you close, the more you earn."
  }, {
    question: "Can I move from junior to senior associate?",
    answer: "Yes. Once you meet your office’s requirements (usually based on your production level or time with the brand), you can request to switch to a senior associate plan."
  }, {
    question: "Can I change offices after joining?",
    answer: "Yes, you can request a transfer to another REMAX office in the country, provided you have agreement from both Broker Owners (your current office and the one you wish to move to). It’s essential to be up to date with your financial and administrative commitments before making the change."
  }, {
    question: "Can I change teams after joining?",
    answer: "Yes. If you work in a team within your office and want to switch to another team or work independently, you can do so following your office’s internal guidelines."
  }, {
    question: "Do I have to meet a minimum production to remain with the brand?",
    answer: "There is no regionally mandated minimum. However, each office may set internal guidelines to evaluate agent productivity. Also remember that, as an independent business, you must generate income to cover your operating costs."
  }, {
    question: "What happens if I don’t sell in a given month?",
    answer: "There is no penalty for not selling in a month. You just need to keep up with your fixed fees (regional and office). The model allows you to manage your time and effort according to your personal goals."
  }, {
    question: "Does REMAX give me properties to sell?",
    answer: "No. You are responsible for sourcing your own listings and clients. However, you work within a collaborative network where you can access exclusive listings from other agents and market them, creating greater business opportunities."
  }, {
    question: "Can I promote and sell other agents’ listings?",
    answer: "Yes. The REMAX model encourages collaboration. You can promote, show, and sell properties listed by agents in your office or even in other REMAX offices, sharing the commission according to agreed terms."
  }, {
    question: "Do I have to keep fixed working hours?",
    answer: "No. You own your time. There is no set schedule or daily attendance requirement. The model offers total flexibility to organize your calendar according to your personal and professional goals."
  }]
};
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/a1-refactor/typography/WsSectionTitle.tsx


var _templateObject;




function WsSectionTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title);
}

/* harmony default export */ var typography_WsSectionTitle = (WsSectionTitle);
var Title = (0,styled/* default */.ZP)(Typography_Typography/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n  text-wrap: wrap;\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));
;// CONCATENATED MODULE: ./pages/preguntas-frecuentes/index.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var PreguntasFrecuentes = function PreguntasFrecuentes(props) {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("faq");
  var faqTitle = translation("title") || "";
  var title = faqTitle;
  var introTitle = translation("introTitle");
  var introBody = translation("introBody");
  var questions = CFrequencyQuestions[props.lang];
  var router = (0,next_router.useRouter)();
  var metaData = {
    title: "frequentQuestions",
    description: "frequentQuestions",
    url: router.asPath,
    og_type: "page-frequentQuestions"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
    container: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverImage, null), (0,emotion_react_browser_esm/* jsx */.tZ)(Content, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BorderForm, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(typography_WsSectionTitle, {
    title: title
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12,
    xl: 8,
    lg: 8,
    md: 10,
    mb: {
      xs: 4,
      md: 0
    },
    mx: "auto"
  }, (introTitle || introBody) && (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Description, null, introTitle && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "intro-title"
  }, introTitle), introBody && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "intro-body"
  }, introBody))), questions.map(function (x, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomAccordion, x));
  }))));
};

var __N_SSG = true;
/* harmony default export */ var preguntas_frecuentes = (PreguntasFrecuentes);

var CustomAccordion = function CustomAccordion(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleChange = function handleChange(event, isExpanded) {
    setExpanded(isExpanded);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(CustomRoot, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Accordion/* default */.Z, {
    expanded: expanded,
    onChange: handleChange
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionSummary/* default */.Z, {
    expandIcon: !expanded ? (0,emotion_react_browser_esm/* jsx */.tZ)(Add/* default */.Z, {
      color: "primary"
    }) : (0,emotion_react_browser_esm/* jsx */.tZ)(Remove/* default */.Z, {
      color: "primary"
    }),
    "aria-controls": "panel1bh-content",
    id: "panel1bh-header",
    className: "faq-clicked"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    className: "question-text"
  }, props.question)), (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionDetails/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    className: "answer-text"
  }, props.answer))));
};

var CoverImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er87hav5"
} : 0)( true ? {
  name: "mdd110",
  styles: "background-image:url(\"/images/v2/pic/image-07.webp\");background-size:cover;background-position:center 50%;background-repeat:no-repeat;width:100%;height:80vh;@media screen and (max-width: 500px){height:45dvh;background-position:center 10%;background-size:contain;}@media screen and (max-width: 500px){height:35dvh;background-position:center 10%;background-size:contain;}"
} : 0);

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "er87hav4"
} : 0)( true ? {
  name: "1uv4m9c",
  styles: "background-color:var(--color-brand-cream-primary);min-height:100vh"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "er87hav3"
} : 0)( true ? {
  name: "pvy8ec",
  styles: "background-color:var(--color-brand-cream-primary);position:relative;width:100%;height:auto"
} : 0);

var BorderForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er87hav2"
} : 0)( true ? {
  name: "1ht0wfl",
  styles: "position:absolute;top:-150px;left:0;width:100%;height:150px;background-color:var(--color-brand-cream-primary);border-radius:150px 0px 0px 0px;display:flex;justify-content:center;align-items:center;@media screen and (max-width: 500px){top:-70px;height:70px;border-radius:0px;}"
} : 0);

var CustomRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er87hav1"
} : 0)( true ? {
  name: "1japsd9",
  styles: "& .MuiPaper-root{background:transparent;box-shadow:none;padding:5px 35px;&.Mui-expanded{background:white!important;border-radius:20px;padding-bottom:10px;margin:10px 0px;&:last-of-type{margin-bottom:10px;}}}& .question-text{color:black;font-size:var(--fs-sub-title-small);font-weight:600;}& .answer-text{color:var(--color-brand-grey-main);font-size:var(--fs-sub-title-small);font-weight:500;}"
} : 0);

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er87hav0"
} : 0)( true ? {
  name: "1u3oeov",
  styles: "width:92%;padding:2rem 3.5rem;border-radius:10px;margin:0 auto 3rem;background:white;color:var(--color-brand-grey-main);font-size:var(--fs-sub-title-small);line-height:1.3;border:1px solid var(--color-brand-grey-light);.intro-title{color:var(--color-text-primary);font-weight:700;margin:0 0 8px;}.intro-body{margin:0;white-space:pre-line;}"
} : 0);

/***/ }),

/***/ 85127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




/**
 *
 * @description Typography component
 * default styles are
 * --font-size body medium,
 *  color --color-brand-grey-main
 *  and weight 400
 * @returns
 */



var Typography = function Typography(props) {
  var _ref, _props$fontWeight;

  var styles = {
    root:
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
      fontFamily: "var(--font-family)",
      fontSize: props.fontSize ? "var(".concat(props.fontSize, ")") : "var(--fs-body-medium)",
      color: (_ref = "var(".concat(props.color, ")")) !== null && _ref !== void 0 ? _ref : "var(--color-brand-grey-main)",
      fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 400
    },  true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    css: styles.root
  }, props), props.children);
};

/* harmony default export */ __webpack_exports__["Z"] = (Typography);

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ }),

/***/ 93583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preguntas-frecuentes",
      function () {
        return __webpack_require__(31298);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,8407,70,3843,7918,8875,2888,179], function() { return __webpack_exec__(93583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);